export default __webpack_public_path__ + "static/media/JH.86f58f4f.svg";